export class ScrollTop {
  constructor({ buttonSelector = '.c-scroll-top', scrollThreshold = 300 }) {
    this.scrollThreshold = scrollThreshold;
    this.button = document.querySelector(buttonSelector);

    if (!this.button) return;

    this.body = document.body;
    this.registerScrollListener();
    this.registerClickListener();
  }

  registerScrollListener() {
    window.addEventListener('scroll', () => {
      if (window.pageYOffset > this.scrollThreshold) {
        this.button.classList.add('is-active');
        this.body.classList.add('is-active-scroll-top');
      } else {
        this.button.classList.remove('is-active');
        this.body.classList.remove('is-active-scroll-top');
      }
    });
  }

  registerClickListener() {
    this.button.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }
}
